export default __webpack_public_path__ + "static/media/myedge-logo.f452bf04.svg";